import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import React from "react";
import { CampaignStatus } from "schemas/dashboard";

interface Props {
  status: CampaignStatus;
  startDate?: string;
}

export const CampaignStatusChip: React.FC<Props> = ({ status, startDate }) => {
  const theme = useTheme();

  const differenceInDays = (start: string) => {
    const today = moment().format("YYYY-MM-DD");
    const end = moment(start).format("YYYY-MM-DD");
    const diff = moment(end).diff(today, "days") + 1;
    if (diff < 1) {
      return "Expiring today!";
    } else if (diff === 1) {
      return "Expiring tomorrow!";
    }
    return `Expiring in ${diff} days!`;
  };

  const statusMap: Record<CampaignStatus, { label: string; color: string }> = {
    [CampaignStatus.in_progress]: {
      label: "in progress",
      color: theme.palette.info.dark,
    },
    [CampaignStatus.complete]: {
      label: "complete",
      color: theme.palette.success.dark,
    },
    [CampaignStatus.pending_approval]: {
      label: "pending approval",
      color: theme.palette.warning.dark,
    },
    [CampaignStatus.expired]: {
      label: "expired",
      color: theme.palette.error.dark,
    },
  };

  const { label, color } = statusMap[status];

  return (
    <Typography
      variant="caption"
      component="span"
      sx={{
        color,
        fontWeight: 600,
        fontSize: 10,
      }}
    >
      {startDate && status === CampaignStatus.pending_approval
        ? differenceInDays(startDate)
        : label}
    </Typography>
  );
};
